/**
 * Created by dimah on 02/07/17.
 */
import { AbstractDTO } from "./abstract";
import { IBreadcrumbs } from "@signature-it/ngx-generic/interfaces";

export class BreadcrumbsDTO extends AbstractDTO implements IBreadcrumbs {
    name: string;
    link: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.name = attributes['name'] || '';
        this.link = attributes['link'] || '';
    }

}
